import React, { useCallback, useMemo } from "react";
import { compose } from "redux";

import withAlertManagement from "../../../../../hocs/withAlertManagement";
import withTranslations from "../../../../../hocs/withTranslations";
import config from "../../../../../config";
import { SID_NOTIFICATION_TYPES } from "../../../../../lib/notifications/sidNotificationTypes";
import { getStrategyDashboardSettingsCategories } from "../../../../../lib/notifications/getStrategyDashboardSettingsCategories";
import AlertManagementSwitchers from "../../../common/AlertManagementSwitchers";

const StrategyNotificationSettingsSwitchers = ({
  alertManagementData,
  loading,
  updateAlertManagementData,
  notificationTypes = SID_NOTIFICATION_TYPES,
  insiderAnalysisCategories,
  analysisCategories,
  transactionStrategies
}) => {
  const { alertCategories, additionalSettingsCategories } = useMemo(
    () =>
      getStrategyDashboardSettingsCategories({
        notificationTypes,
        configAlertCategories: config.alertCategories,
        apiSettingsCategories: [
          ...insiderAnalysisCategories,
          ...analysisCategories,
          ...transactionStrategies
        ]
      }),
    [
      notificationTypes,
      insiderAnalysisCategories,
      analysisCategories,
      transactionStrategies
    ]
  );

  const handleChange = useCallback(
    element => {
      element.channels.forEach(channel => {
        updateAlertManagementData({
          channel,
          category: element.category,
          status: element.status
        });
      });
    },
    [updateAlertManagementData]
  );

  return (
    <AlertManagementSwitchers
      data={alertManagementData ?? null}
      disabled={loading}
      onElementChange={handleChange}
      alertCategories={alertCategories}
      additionalSettingsCategories={additionalSettingsCategories}
    />
  );
};

export default compose(
  withTranslations,
  withAlertManagement
)(StrategyNotificationSettingsSwitchers);
